export default __webpack_public_path__ + "static/media/halibut_thumb.8afc4aaf.jpg";